import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import type { SpaceSerialized } from '@playq/octopus2-apps';
import { Space } from '@playq/octopus2-apps';

import type { RootState } from '/store/RootState';

interface IActiveSpaceState {
  activeSpace: SpaceSerialized | undefined;
}

const initialState: IActiveSpaceState = {
  activeSpace: undefined,
};

const activeSpaceSlice = createSlice({
  name: 'activeSpace',
  initialState,
  reducers: {
    reset: () => initialState,
    put: (state, action: PayloadAction<SpaceSerialized | undefined>) => {
      state.activeSpace = action.payload;
    },
  },
});

export const activeSpaceToolkit = Object.freeze({
  initialState,
  actions: activeSpaceSlice.actions,
  selectors: {
    activeSpace: (state: RootState) =>
      !_.isNil(state.activeSpace.activeSpace) ? new Space(state.activeSpace.activeSpace) : undefined,
  },
});

export const activeSpaceReducer = activeSpaceSlice.reducer;
